import { Checkbox, FormControlLabel, Stack, Typography } from '@mui/material';
import { ChangeEvent, memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../../../../store';
import { setAlsoImportAppointmentCalendar } from '../../../../store/import';

// Mostrata solo con turno diviso e formato Factorial: il file Factorial ha una sola fascia
// oraria, che senza questa scelta finisce solo nel turno di lavoro
export const AppointmentCalendarOption = memo(() => {
  const { alsoImportAppointmentCalendar } = useSelector(
    (state: RootState) => state.rotaImport
  );
  const dispatch = useDispatch<AppDispatch>();

  const handleOnChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      dispatch(setAlsoImportAppointmentCalendar(event.target.checked));
    },
    [dispatch]
  );

  return (
    <Stack sx={{ pt: 1 }}>
      <FormControlLabel
        label="Importa anche come turno appuntamento"
        control={
          <Checkbox
            checked={alsoImportAppointmentCalendar}
            onChange={handleOnChange}
          />
        }
      />
      <Typography>
        Con la casella attiva, gli orari del file vengono scritti anche nel
        turno appuntamento. Per ogni utente, dal suo primo al suo ultimo giorno
        nel file, le modifiche fatte a mano al turno appuntamento vengono
        sostituite e i giorni senza orario risultano chiusi.
      </Typography>
    </Stack>
  );
});
